export const LAB_SETTINGS_RETRIEVE_REQUESTED = 'LAB_SETTINGS_RETRIEVE_REQUESTED';
export const LAB_SETTINGS_RETRIEVE_SUCCEED = 'LAB_SETTINGS_RETRIEVE_SUCCEED';
export const LAB_SETTINGS_RETRIEVE_FAILED = 'LAB_SETTINGS_RETRIEVE_FAILED';

export const LAB_SETTINGS_ADVICE_CREATE_REQUESTED = 'LAB_SETTINGS_ADVICE_CREATE_REQUESTED';
export const LAB_SETTINGS_ADVICE_CREATE_SUCCEED = 'LAB_SETTINGS_ADVICE_CREATE_SUCCEED';
export const LAB_SETTINGS_ADVICE_CREATE_FAILED = 'LAB_SETTINGS_ADVICE_CREATE_FAILED';

export const LAB_SETTINGS_ADVICE_UPDATE_REQUESTED = 'LAB_SETTINGS_ADVICE_UPDATE_REQUESTED';
export const LAB_SETTINGS_ADVICE_UPDATE_SUCCEED = 'LAB_SETTINGS_ADVICE_UPDATE_SUCCEED';
export const LAB_SETTINGS_ADVICE_UPDATE_FAILED = 'LAB_SETTINGS_ADVICE_UPDATE_FAILED';

export const LAB_SETTINGS_ADVICE_DELETE_REQUESTED = 'LAB_SETTINGS_ADVICE_DELETE_REQUESTED';
export const LAB_SETTINGS_ADVICE_DELETE_SUCCEED = 'LAB_SETTINGS_ADVICE_DELETE_SUCCEED';
export const LAB_SETTINGS_ADVICE_DELETE_FAILED = 'LAB_SETTINGS_ADVICE_DELETE_FAILED';

export const LAB_SETTINGS_FEE_UPDATE_REQUESTED = 'LAB_SETTINGS_FEE_UPDATE_REQUESTED';
export const LAB_SETTINGS_FEE_UPDATE_SUCCEED = 'LAB_SETTINGS_FEE_UPDATE_SUCCEED';
export const LAB_SETTINGS_FEE_UPDATE_FAILED = 'LAB_SETTINGS_FEE_UPDATE_FAILED';
